export default __webpack_public_path__ + "789afb71d327988e2fc88816802fdb44.woff2";